import { FormControlLabel, Radio, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

export interface SelectionWithDescriptionProps {
    label: string;
    description: string;
    checked: boolean;
    onChangeFn: (value: boolean) => void;
    isReady?: boolean;
    disabled?: boolean;
}

export function SelectionWithDescription({
    label,
    description,
    checked,
    onChangeFn,
    isReady = true,
    disabled = false,
}: SelectionWithDescriptionProps): JSX.Element {
    return (
        <>
            <FormControlLabel
                control={<Radio size="small" />}
                checked={isReady ? checked : false}
                label={label}
                color="secondary"
                onChange={(_e, value) => onChangeFn(value)}
                disabled={disabled}
            />
            {description && (
                <Typography
                    variant="inherit"
                    color="gray"
                    sx={{
                        margin: '0px 0px 30px',
                    }}
                >
                    {description}
                </Typography>
            )}
        </>
    );
}

export default SelectionWithDescription;
